__turbopack_context__.v({
  "Field": "index-module__IpqpUG__Field",
  "Item": "index-module__IpqpUG__Item",
  "ItemDescription": "index-module__IpqpUG__ItemDescription",
  "ItemIndicator": "index-module__IpqpUG__ItemIndicator",
  "ItemLabel": "index-module__IpqpUG__ItemLabel",
  "ItemText": "index-module__IpqpUG__ItemText",
  "Label": "index-module__IpqpUG__Label",
  "List": "index-module__IpqpUG__List",
  "Popup": "index-module__IpqpUG__Popup",
  "Positioner": "index-module__IpqpUG__Positioner",
  "ScrollArrow": "index-module__IpqpUG__ScrollArrow",
  "Select": "index-module__IpqpUG__Select",
  "ValuePrimary": "index-module__IpqpUG__ValuePrimary",
  "ValueSecondary": "index-module__IpqpUG__ValueSecondary",
  "ValueText": "index-module__IpqpUG__ValueText",
});
